import moment from 'moment';

const getChain = (
    position,
    chain,
    positionWithConnection,
    lastLaborPositionGuid,
    positions,
    isFirst = false
) => {
    const filteredPosition = positionWithConnection.filter(({ guid }) => guid !== position.guid);

    let follower = [];

    if (isFirst) {
        const followers = position.connections
            .filter((connection) => connection.type === 1 && connection.from === position.guid)
            .map((connection) => positions[connection.to])
            .sort(
                (positionA, positionB) =>
                    moment(positionA.planned.end_date).valueOf() -
                    moment(positionB.planned.end_date).valueOf()
            );

        const findFollower = followers
            .filter((position) => position.planned.start_date === followers[0].planned.start_date)
            .sort(
                (positionA, positionB) =>
                    Number(positionA.planned.days_count) - Number(positionB.planned.days_count)
            )[0];

        follower = findFollower ? [findFollower] : [];
    }

    let result = {
        chain: [...chain, ...follower, position],
        positionWithConnection: [...filteredPosition],
    };

    const connectionTo = position.connections.find(
        (connection) => connection.from === position.guid
    );
    if (!connectionTo || lastLaborPositionGuid === position.guid) return result;

    const nextPosition = positionWithConnection.find(
        (position) => position.guid === connectionTo.to
    );

    if (!nextPosition) {
        return result;
    }

    const { chain: chainResult, positionWithConnection: positionWithConnectionResult } = getChain(
        nextPosition,
        [...chain],
        filteredPosition,
        lastLaborPositionGuid,
        positions
    );

    return {
        chain: [...result.chain, ...chainResult],
        positionWithConnection: positionWithConnectionResult,
    };
};
export const getChains = (positionWithConnection, lastLaborPositionGuid, positions = {}) => {
    const sortedChain = [...positionWithConnection].sort(
        (positionA, positionB) =>
            moment(positionA.planned.end_date).valueOf() -
            moment(positionB.planned.end_date).valueOf()
    );

    if (!sortedChain.length) {
        return [];
    }
    let result = [];

    const chain = getChain(sortedChain[0], [], sortedChain, lastLaborPositionGuid, positions, true);
    // const chain = getChainConnection(sortedChain[0], positions);

    result.push(chain.chain);
    // result.push(chain);

    result = [
        ...result,
        ...getChains(chain.positionWithConnection, lastLaborPositionGuid, positions),
    ];

    return result;
};
